import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Fi from "../Field/Fi";

export default function NumberVerifyModal({ open, setOpen }) {
  const handleClose = () => setOpen(false);
  const [error, setError] = React.useState(false);
  const ref1 = React.useRef();
  const ref2 = React.useRef();
  const ref3 = React.useRef();
  const [num1, setNum1] = React.useState("");
  const handleNum1 = (e) => {
    const val = e.target.value;
    if (val.length > 1) {
      setNum1(val[1]);
    } else {
      setNum1(val);
    }
    ref1.current.focus();
  };
  const [num2, setNum2] = React.useState("");
  const handleNum2 = (e) => {
    const val = e.target.value;
    if (val.length > 1) {
      setNum2(val[1]);
    } else {
      setNum2(val);
    }
    ref2.current.focus();
  };
  const [num3, setNum3] = React.useState("");
  const handleNum3 = (e) => {
    const val = e.target.value;
    if (val.length > 1) {
      setNum3(val[1]);
    } else {
      setNum3(val);
      ref3.current.focus();
    }
  };
  const [num4, setNum4] = React.useState("");
  const handleNum4 = (e) => {
    const val = e.target.value;
    if (val.length > 1) {
      setNum4(val[1]);
    } else {
      setNum4(val);
    }
    ref3.current.blur();
  };
  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "600px",
            maxHeight: "327px",
            bgcolor: "#FFFFFF",
            boxShadow:
              "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2)",
            outline: "none",
            borderRadius: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              alignItems: "center",
              padding: "24px",
            }}
          >
            <CloseIcon
              onClick={handleClose}
              sx={{
                color: "text.primary",
                marginLeft: "2px",
                "&:hover": {
                  cursor: "pointer",
                },
              }}
            />
            <Typography
              variant="subtitle1"
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="600"
              lineHeight="24px"
              color="black"
              sx={{
                margin: "auto",
              }}
            >
              Confirm your number to login
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "1px",
              backgroundColor: "#D6D6D6",
            }}
          ></Box>
          <Box
            sx={{
              height: "254px",
              padding: "24px",
              overflowY: "scroll",
              "::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <Heading text="Enter Code" />
            <Typography
              variant="body1"
              fontSize="16px"
              fontWeight="400"
              lineHeight="24px"
              color="#616161"
              sx={{ marginTop: "4px" }}
            >
              Enter the code we sent over to +971561234567
            </Typography>
            <Box sx={{ display: "flex", columnGap: "26px", marginTop: "24px" }}>
              <Fi
                height="46.29px"
                sx={{ width: "46px" }}
                inputStyle={{ fontSize: "16px" }}
                inputPropsSx={{ paddingLeft: "3px" }}
                label=""
                helperText=""
                value={num1}
                handleChange={handleNum1}
                error={error}
                autoFocus
              />
              <Fi
                height="46.29px"
                sx={{ width: "46px" }}
                inputStyle={{ fontSize: "16px" }}
                inputPropsSx={{ paddingLeft: "3px" }}
                label=""
                error={error}
                helperText=""
                value={num2}
                handleChange={handleNum2}
                inputRef={ref1}
              />
              <Fi
                height="46.29px"
                sx={{ width: "46px" }}
                inputStyle={{ fontSize: "16px" }}
                inputPropsSx={{ paddingLeft: "3px" }}
                label=""
                helperText=""
                error={error}
                value={num3}
                handleChange={handleNum3}
                inputRef={ref2}
              />
              <Fi
                height="46.29px"
                sx={{ width: "46px" }}
                inputStyle={{ fontSize: "16px" }}
                inputPropsSx={{ paddingLeft: "3px" }}
                label=""
                helperText=""
                error={error}
                value={num4}
                handleChange={handleNum4}
                inputRef={ref3}
              />
            </Box>
            {error && (
              <Typography
                variant="body1"
                fontSize="16px"
                fontWeight="400"
                lineHeight="24px"
                color="error.main"
                sx={{ marginTop: "8px" }}
              >
                The code is not valid, please try again.
              </Typography>
            )}
            <Box sx={{ display: "flex", marginTop: "24px" }}>
              <Typography
                variant="body1"
                fontSize="16px"
                fontWeight="400"
                lineHeight="24px"
                color="text.primary"
                sx={{ marginRight: "5px" }}
              >
                Didn't receive the code?
              </Typography>
              <Typography
                variant="subtitle1"
                fontSize="16px"
                fontWeight="600"
                lineHeight="24px"
                color="primary.main"
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                Try again
              </Typography>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

function Heading({ text }) {
  return (
    <Typography
      variant="subtitle1"
      fontSize="22px"
      fontWeight="600"
      lineHeight="26px"
      color="text.primary"
    >
      {text}
    </Typography>
  );
}
